import { Upload } from 'lucide-react'
import PropTypes from 'prop-types'
import { useRef } from 'react'
import { cn } from 'lib/utils'

import { AdasBox, AdasTypography } from '@components/wrapper-components'
import { useIsReadOnly } from '@hooks/useIsReadOnly'
import { useMessageStore } from '../../store'
import { MIME_TYPES_MAP } from '../../variable-maps'

export const AddFileButton = ({ setAdditionalDocuments, disabled: disabledProp = false }) => {
  // Uploading is a write; folding it into `disabled` covers every caller at once.
  const isReadOnly = useIsReadOnly()
  const disabled = disabledProp || isReadOnly
  const fileRef = useRef(null)
  const addMessage = useMessageStore((store) => store.addMessage)

  const handleUpload = () => {
    const file = fileRef.current.files[0]
    if (!file) {
      return
    }

    const suppoprtedFileTypes = Object.values(MIME_TYPES_MAP)
    if (!suppoprtedFileTypes.includes(file.type)) {
      addMessage({ text: 'File format not supported!' })
      return
    }

    setAdditionalDocuments((prev) => {
      prev.push(fileRef.current.files[0])
      const data = [...prev]
      return data
    })
  }

  return (
    <label
      className={cn(
        'flex items-center justify-between gap-4 rounded-xl border border-[#D1D5D8] bg-white px-4 py-3 transition-colors',
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-[#F8FAFC]'
      )}
    >
      <AdasBox className='flex items-center gap-3 min-w-0'>
        <AdasBox className='flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-[#E8EFFF]'>
          <Upload className='h-5 w-5 text-[#0A1628]' strokeWidth={1.75} />
        </AdasBox>
        <AdasBox className='min-w-0'>
          <AdasTypography className='text-[15px] font-bold text-[#0A1628]'>Additional Document</AdasTypography>
          <AdasTypography className='mt-0.5 text-[13px] text-[#6B7280]'>Any extra file you want to attach to this quote</AdasTypography>
        </AdasBox>
      </AdasBox>
      <span
        className={cn(
          'shrink-0 rounded-full bg-[#1F6FEB] px-5 py-2 text-[12px] font-bold uppercase tracking-wide text-white transition-colors',
          !disabled && 'hover:bg-[#1A5FD0]'
        )}
      >
        Upload
      </span>
      <input
        ref={fileRef}
        type='file'
        hidden
        disabled={disabled}
        onChange={handleUpload}
        accept='.jpg, .jpeg, .png, .pdf, .doc, .docx, .txt'
      />
    </label>
  )
}

AddFileButton.propTypes = {
  setAdditionalDocuments: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}
